import styles from './AcademyGridCard.module.scss';
import classNames from 'classnames';
import { Picture, LinkButton, LinkButtonProps, Heading } from 'ui/components/1-atoms';
import IconArrowRight from 'ui/icons/icon-arrow-right-web.svg';

export interface AcademyGridCardProps {
	className?: string;
	image?: Umbraco.Image;
	heading?: string;
	description?: string;
	linkButton?: Umbraco.Link;
	linkButtonAriaLabel?: string;
}

export const AcademyGridCard: React.FC<AcademyGridCardProps> = ({ className, heading, linkButton, image, description, linkButtonAriaLabel }) => {
	return (
		<div className={classNames(styles.AcademyGridCard, className)}>
			{image && (
				<Picture
					url={image?.url}
					sizes="100vw"
					properties={{
						altText: image?.properties?.altText,
					}}
					className={styles.AcademyGridCard_image}
				/>
			)}
			<div className={classNames(styles.AcademyGridCard_academyInfo, styles.AcademyGridCard_academyInfo___top)}>
				{heading && (
					<Heading headingLevel="h3" className={styles.AcademyGridCard_heading}>
						{heading}
					</Heading>
				)}
			</div>
			<div className={classNames(styles.AcademyGridCard_academyInfo, styles.AcademyGridCard_academyInfo___bottom)}>
				{description && <div dangerouslySetInnerHTML={{ __html: description }} className={styles.AcademyGridCard_description}></div>}
				{linkButton && (
					<LinkButton
						style="secondaryWeb"
						url={linkButton?.url}
						title={linkButtonAriaLabel}
						ariaLabel={linkButtonAriaLabel}
						withBackIcon={<IconArrowRight />}
					>
						{linkButton?.name}
					</LinkButton>
				)}
			</div>
		</div>
	);
};
